(function () {
  let cartDrawer = document.querySelector("#CartDrawer");

  window.addEventListener("load", (event) => {
    console.log("page is fully loaded");
    setTimeout(function () {
      // Swym's Wishlist Plus SDK. Its app embed is off, so usually there's nothing to listen to.
      if (!window._swat?.evtLayer) return;

      window._swat.evtLayer.addEventListener("sw:addedtocart", function (e) {
        refreshCartDrawer();
      });

      window._swat.evtLayer.addEventListener("sw:addedalltocart", function (e) {
        refreshCartDrawer();
      });
    }, 3000);
  });

  function refreshCartDrawer() {
    function handleResponse() {
      console.log(JSON.parse(this.responseText));
      renderContents({
        sections: JSON.parse(this.responseText),
      });
    }
    const request = new XMLHttpRequest();
    request.addEventListener("load", handleResponse);
    request.open("GET", "/?sections=cart-drawer", true);
    request.send();
  }

  function setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id,
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open"),
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  function open() {
    const cartDrawerNote = document.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      cartDrawer.classList.add("animate", "active");
    });

    cartDrawer.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = cartDrawer.classList.contains("is-empty")
          ? cartDrawer.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          cartDrawer.querySelector(".drawer__inner") ||
          cartDrawer.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true },
    );

    document.body.classList.add("overflow-hidden");
  }

  function close() {
    cartDrawer.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  function getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  function getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
    ];
  }

  function renderContents(parsedState) {
    document.querySelector(".drawer").classList.remove("is-empty");
    getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector,
      );
    });

    setTimeout(() => {
      document
        .querySelector("#CartDrawer-Overlay")
        .addEventListener("click", close);
      open();
    });
  }
})();
